
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"affected-view-tile.related-geometry":"Betroffenes Geometrieattribut:","affected-view-tile.related-geometry.button":"Anpassen"},"en":{"affected-view-tile.related-geometry":"Affected geometry attribute:","affected-view-tile.related-geometry.button":"Adjust"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();